import {
  Box, Grid, Typography, Tooltip
} from '@material-ui/core';
import makeStyles from "@material-ui/core/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
  statusContainer:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'flex-start',
    alignItems:'center',
    height:'8rem',
  },
  iconContainer: {
    borderRadius:'50%',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
  },
  iconLabel: {
    color:'black',
    fontSize:'0.7rem',
    fontWeight:'700',
    marginTop:'0.5rem',
    textAlign: 'center'
  },
  numberLabel: {
    color:'black',
    fontSize:'0.9rem',
    fontWeight:'bold',
    marginBottom:'0.5rem',
    textAlign: 'center'
  }
}));
export const PrateleiraInfinitaIcon = ({
  icon,
  label,
  number,
  onClick,
  tooltip,
  problem,
  tooltipMessage
}) => {
  const classes = useStyles();
  const innerColor = problem ? 'rgba(232,41,8,0.75)' : 'rgba(16,157,84,0.75)';
  const outerColor = problem ? 'rgba(154,35,14,0.8)' : 'rgba(18,89,19,0.8)';

  return (
    <Tooltip title={tooltip ? tooltipMessage : ''} placement="top" arrow>
      <Grid item xs={12} className={classes.statusContainer} onClick={onClick}>
        <Typography className={classes.numberLabel}>{number}</Typography>
        <div style={{border:`0.15rem solid ${outerColor}`, padding:'0.1rem'}} className={classes.iconContainer}>
          <div 
            className={classes.iconContainer}
            style={{
              padding:'0.5rem',
              backgroundColor: innerColor
            }} 
          >
            <Box
              component={icon}
              style={{color:'black'}}
              width={"2rem!important"}
              height={"2rem!important"}
            />
          </div>
        </div>
        <Typography className={classes.iconLabel}>{label}</Typography>
      </Grid>
    </Tooltip>
  )
}